
export default {
  print: {
    print: 'Imprimer',
    segment: 'Segment',
    preparingPrinting: 'Préparation de l\'impression',
    readyToPrint: 'Prêt à imprimer'
  }
}
